import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private baseUrl: string = environment.baseUrl;

	constructor(private http: HttpClient) { }

	login(username: string, password: string, role_id: string): Observable<any> {
		const url = `${this.baseUrl}/auth/login`;
		const body = { username, password, role_id };
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

		return this.http.post(url, body, { headers }).pipe(
			catchError(this.handleError)
		);
	}

	private handleError(error: any): Observable<never> {
		return throwError(error.error.message || error);
	}
}
